import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { fromPromise } from 'rxjs/observable/fromPromise';

import { getSsoConfig } from 'api/sso/service';

import { getSsoConfigFailed, setSsoConfig, setSsoPageNavigated } from './actions';

/* eslint-disable import/prefer-default-export */
export const AUTH_GET_SSO_CONFIG = (action$) =>
  action$.pipe(
    switchMap(() =>
      fromPromise(getSsoConfig()).pipe(
        map(({ data, success }) => {
          setSsoPageNavigated(false);
          return success ? setSsoConfig(data) : getSsoConfigFailed();
        }),
        catchError(() => of(getSsoConfigFailed()))
      )
    )
  );
